/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum WorkLocation {
  Onsite = "Onsite",
  Remote = "Remote",
  Hybrid = "Hybrid",
  NoPreference = "NoPreference",
}

export const WorkLocationDisplay: Record<WorkLocation, string> = {
  [WorkLocation.Onsite]: "Onsite",
  [WorkLocation.Remote]: "Remote",
  [WorkLocation.Hybrid]: "Hybrid",
  [WorkLocation.NoPreference]: "No Preference",
};
